import api from "./api";

export async function getAllCategories(limit = 20) {
  try {
    const response = await api.get('/categories/index', {
      params: { limit } // ✅ correct way to send query params
    });

    // Make sure your backend returns a `status` field, or check the HTTP status code
    if (response.data.status === 'success') {
      return response.data.data.data; // adjust according to your response structure
    }

    return []; // fallback
  } catch (error) {
    console.error('Failed to fetch categories:', error);
    return [];
  }
}
